import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ConcurCopySource } from 'app/model/pipeline/copysource/concur.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ConcurCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class ConcurCopySourceAdapter extends CopySourceAdapter<ConcurCopySource, Model.ConcurSource> {
    protected override async _toResource(copySource: ConcurCopySource): Promise<Model.ConcurSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(ConcurCopySource).name);
    }

    protected override async _toModel(
        resource: Model.ConcurSource,
        copyActivity: CopyActivity
    ): Promise<ConcurCopySource> {
        return this._toTabularModel(resource, copyActivity, ConcurCopySource.MODEL);
    }
}
